export enum SelectionSide {
    Home = 1,
    Draw = 2,
    Away = 3
}